import React from "react"
import { ResponsiveEmbed } from "react-bootstrap"

const Youtube = ({ link }) => {
  return (
    <ResponsiveEmbed
      aspectRatio="16by9"
      className="border-powder"
      style={{ border: "3px dashed" }}
    >
      <iframe
        title="youtube-video"
        className="p-2"
        width="560"
        height="315"
        src={link}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </ResponsiveEmbed>
  )
}

export default Youtube
